<template>
  <div class="login-container">
    <div class="login-background">
      <div class="login-overlay"></div>
      <div class="login-content">
        <div class="login-card">
          <div class="login-header">
            <div class="logo-container">
              <img 
                :src="require('@/assets/logo/favicon.png')" 
                alt="Logo" 
                class="logo"
              />
            </div>
            <h1 class="login-title">Masuk Admin Sidasi</h1>
            <p class="login-subtitle">Silakan masuk ke akun Anda</p>
          </div>

          <div class="login-form">
            <ValidationObserver ref="observer">
              <v-form class="form-content">
                <ValidationProvider 
                  name="username" 
                  rules="required" 
                  v-slot="{ errors }">
                  <v-text-field
                    v-on:keyup.enter="recaptcha()"
                    class="no_box"
                    outlined
                    dense
                    :color="'#17723c'"
                    placeholder="Username"
                    prepend-inner-icon="mdi-account-outline"

                    vv-uppercase

                    v-model="form.username"
                    :error-messages="errors"
                    required>
                  </v-text-field>
                </ValidationProvider>

                <ValidationProvider 
                  name="password" 
                  rules="required|min:5|max:20" 
                  v-slot="{ errors }">
                  <v-text-field
                    v-on:keyup.enter="save()"
                    class="no_box"
                    outlined
                    dense
                    :color="'#17723c'"
                    placeholder="Password"
                    :type="show ? 'text' : 'password'"
                    prepend-inner-icon="mdi-lock-outline"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show = !show"
                    :counter="20"

                    vv-uppercase
                    
                    v-model="form.password"
                    :error-messages="errors"
                    required>
                  </v-text-field>
                </ValidationProvider>

                <div v-if="message.error.length > 0" class="error-message">
                  <div class="error-content">
                    <v-icon size="20" color="#ef4444">mdi-alert-circle-outline</v-icon>
                    <span>{{ message.error }}</span>
                  </div>
                </div>

                <v-btn
                  v-on:keyup.enter="save"
                  :disabled="process.form"
                  :loading="process.form"
                  @click="recaptcha()"
                  block
                  x-large
                  elevation="0"
                  class="login-button"
                  :style="{ background: `linear-gradient(135deg, #17723c, #17723c)` }">
                  <span class="button-text">Masuk</span>
                </v-btn>
              </v-form>
            </ValidationObserver>
          </div>

          <div class="login-footer">
            <p class="footer-text">© 2024 Bagian Pembangunan Kabupaten Klaten. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import axios from "axios";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    export default {
      data() {
        return {
          show: false,
          form: {
            username: '',
            password: '',
            device: 'web'
          },
          process: {
            form: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      computed: {
        rps() {
          return this.$vuetify.breakpoint.name
        },
        company () {
          return this.$store.state.company
        },
        set_color () {
          return this.$store.state.color || '#DD5826'
        },
        set_color_rgb () {
          if (!this.$store.state.color) return 'rgba(221, 88, 38, 0.97)'
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          if (!this.$store.state.color) return 'rgba(256, 125, 38, 0.97)'
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
        }
      },
      mounted () {
        this.fetch()
  
        let counter = {
          total_company_quota: 0,
          total_company_quota_used: 0,
          total_company_quota_sisa: 0
        }
  
        TokenService.saveCounter(JSON.stringify(counter))
  
        this.$store.commit("setCounter", counter)
      },
      methods: {
        async fetch () {
          try {
            await get('config')
            .then(response => {
              let res = response.data
                
              if (res.status === 200) {
                res.results.data[0].color = JSON.parse(res.results.data[0].color)
    
                TokenService.saveCompany(JSON.stringify(res.results.data[0]))
    
                this.$store.commit("setCompany", res.results.data[0])
                
                if (res.results.data[0].color.length > 0) {
                  res.results.data[0].color.map((obj) => {
                    if (obj.active) {
                      TokenService.saveColor(obj.hex)
    
                      this.$store.commit("setColor", obj.hex)
                    }
                  })
                } else {
                  TokenService.saveColor('#DD5826')
    
                  this.$store.commit("setColor", '#DD5826')
                }
              }
            })
          } catch (error) {
            console.log('Config API not available, using default color')
            // Set default color if API is not available
            TokenService.saveColor('#DD5826')
            this.$store.commit("setColor", '#DD5826')
          }
        },
  
        async recaptcha() {
          this.message.error = ''
          // (optional) Wait until recaptcha has been loaded.
          const isValid = await this.$refs.observer.validate()
          if (isValid) {
            this.process.form = true
            await this.$recaptchaLoaded()
  
            // Execute reCAPTCHA with action "login".
            const token = await this.$recaptcha('login')
  
            // let formData = new FormData()
            //       formData.append('secret', '6LdXR4oqAAAAAL5KjnCLuncKPczuNlUCSsGgN7Gl')
            //       formData.append('response', '03AFcWeA5W_bPdL1iPsBMELSrK24b91zCMYrK30Pko2P2rbwDy0cfubF9qVXxKRBm-bgxBMmdvHjmPVlvOjZcorbWk_1CsVkSCL_r47WwINJOvXo-nH0ndzCLKgA1UG2W0b_XR8mSkbnF-gu5Cmg_Ahfofcq2YCbuaGvZJZSTO57MJktMsZo5g3-ZkRyqO7O-WozMhLzZ9xiqPI-Av7uOTmjyTHrXlmCxL2d8tXZHpKzcu3pnLx7tfU6858tRaDcmfThwGnf-ll5Qs4ha0OsWb5Vq6Lgwu63RgqWi4FYNVNktM2jD9Z4IzpDokFNCN16qH2bGxofr9g1-wx7uG4OWLwN_Lniy84if5Tm1YhRUCRCQWE7cRNCurKg_QpmxsHo2hj0weokq70eLVeOnzqgqqKc3eMMiDW7txv3c_Fa1KX4Um2zGDoXrDwJey5j1Aho_5h0ApxaVql3bRJ8IVRPpPBhOxb8VWQD90cYanbu6YpIyEbT6QzSGAK3JRC8axsyLbuDF9OFwgGnJagVKolwKIQUPRW6IBJjzhDhwr4rX_UvPX4ext4jp8PtyyfCwaQEjGzZcdHxOkDhupQcnsY7uuGkGrVmObo_GeMS2RCz2pFsbUDss9qrrENl1cDe87WaKkKSQ2xPbRJIV5ertFY0CJnwzD6sM9xrZmX7PlWwyIZDuVwqTOHNeTHpDAnKsI_tNxPUAgxo93BZDsaloQPcYQbc_mr2NxKi4a-y7ZmxmaXMUVR-VDrQX_NvTC7cgHqxcpGvMmz6eSD8YH3lLPn4jMMZA3SnIRvH1Uwx_Ix2BPRKFNQESZVsVyuslKOlRmlnskx7zCAqi_rhbvqkum2ZefCXOwIGT9Lv9vWtq6fDr9e_X-UxbUVV3QEGJK11sEfdF1xr6oSX_HDofNSfNWYd9DhbULocYV0k3L8PE5zUueQfvlwZe6pLn8rEoDNnXtbsiwfgEZfLM9IhtOBDyVeFjHjNgxclHg6VV8SDxYuuYh5yoT6xNWzg_KDZhxxXQrj8BD_a66EimgJKe84k_dCufwdAyDDwg9H7HPIx2OGnk3AhpeWSnT8bHH0Gu_Pk1A5csxHoxAvOcH8_J7k80nePFMoPu82vY74Emtd7WdcTkJSfGhwGDCCDLHBL2UpyoJtakrJE36OtCgnCOxNek8qTZnuyIIHJuR4taqr2KdAmCnAefngo7CSTzQIKR3-b-vNzTpe4_KXxBl7MlSxM2kh4W7_BeBdYrYRz7Zc_4CvP_Q050ebnOuBw6GTPOOKf0g3sSdqUptoAYE4JmYJfaPmCru57WpDJkAM3vT4-C9jXTOqAm5q_-vW5ABpIPvMMFlp5mROShue-XUyQxrVy6ZV_vftT8O3A3lroia5q8Z6moj46zV5BLBMsqZhOVghuUV_JOJnGt-z-FDK7xF8-Rxa2LnYCyLCAMhCT6Y3jkDmvAGxw0yn7sC6cHH9o9ePRcxF3P3XB0stz_e3m10CnL-oxO-dhVwzqhlFvJt4LX67Aepzh_rul084oW0iBFSVHOjj6OqWGiAgsaFMGTda0M7iGkTX2eEE1uahNsuO3jWBIQyoB8a-bT6mi5dt8h8U9WNeuiCNsoxNNPCKtaSk8sqJallrtYLyIvdssYO4iRXewyEaPo5V6O1J2yYEQQJ8wI3tO3Cead-wsKGbtWx7cclyL5vz9mspPmMNoPDmnPBvUhauhlOyBt7gwNdFJnpk3p8nsMsnxMqGf-2FUjJaWjdIPb7C7Ikf-ywL0FQX0_PyDM7KGawS-Y6gOz1P8Ssol3MgH6xQwlynufpcIiBdhl0iwJhTkS1ofLGb2dUHywYi1ae5WbSEhXBy6umVgGBCRZ12WdjmsPKy-CUIegjpxaqpyiIyS7Kv5x0h41MMHajXJ3wxffrQSfWWilNr8TFPZfI4AHi3bAnNz36_EP4')
  
            //   await fetch(`https://www.google.com/recaptcha/api/siteverify`, {
            //     method: 'POST',
            //     mode: 'no-cors',
            //     body: formData
            //   })
            //   .then(res => res.json())
            //   .then(response => {
            //     console.log(response)
            //   })
  
            let params = {
              // secret: '6Lf8XowqAAAAAHog6hbEywGNn53pqd5YEPLGAfHM',
              token: token,
              email: this.form.username,
            }
  
            await axios({
              url: `${process.env.VUE_APP_API_URL}admin/auth/validate`,
              method: 'POST',
              data: params,
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: process.env.VUE_APP_XAUTH
              }
            }).then((response) => {
              let res = response
              this.captcha = res.data.results.data.success
  
              if (this.captcha) {
                this.save(res.data.results.data.token)
              } else {
                this.process.form = false
                this.message.error = 'Kami menduga adanya aktivitas otomatis. Harap coba lagi untuk mengonfirmasi bahwa Anda adalah pengguna asli'
              }
              
            })
          }
  
          // Do stuff with the received token.
        },
  
        async save (token) {
          this.message.error = ''
  
          const isValid = await this.$refs.observer.validate()
          if (isValid) {
            this.process.form = true
  
            await post('admin/auth/login', {
              data: {
                username: this.form.username,
                password: this.form.password,
                device: this.form.device,
                token: token
              }
            })
            .then(response => {
              let res = response.data
  
              if (res.status === 200) {
                // console.log(res.results.data)
                let user = res.results.data,
                    menu = []
  
                if (user.role === 'admin') {
                  menu = [
                    {
                      title: 'Dashboard',
                      icon: require('@/assets/icon/dashboard.png'),
                      link: '/dashboard',
                      active: true,
                      sub_menu: []
                    },
                    {
                      title: 'Anggaran Murni',
                      icon: require('@/assets/icon/program.png'),
                      link: '/program',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Anggaran P1',
                      icon: require('@/assets/icon/program.png'),
                      link: '/program-p1',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Anggaran Perubahan',
                      icon: require('@/assets/icon/update.png'),
                      link: '/program-perubahan',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Laporan',
                      icon: require('@/assets/icon/laporan.png'),
                      link: '/laporan',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Perkembangan Fisik & Keuangan',
                          link: '/laporan/perkembangan',
                          active: false
                        },
                        {
                          title: 'Capaian Kinerja',
                          link: '/laporan/capaian',
                          active: false
                        },
                        {
                          title: 'Kendala',
                          link: '/laporan/kendala',
                          active: false
                        },
                        {
                          title: 'Rekap OPD',
                          link: '/laporan/rekapitulasi',
                          active: false
                        }
                      ]
                    },
                    {
                      title: 'Perbandingan SP2D',
                      icon: require('@/assets/icon/comparison.png'),
                      link: '/perbandingan-sp2d',
                      active: true,
                      sub_menu: []
                    },
                    {
                      title: 'User',
                      icon: require('@/assets/icon/user.png'),
                      link: '/user',
                      active: true,
                      sub_menu: []
                    },
                    {
                      title: 'Konfigurasi',
                      icon: require('@/assets/icon/setting.png'),
                      link: '/master',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Perangkat Daerah',
                          icon: require('@/assets/icon/company.png'),
                          link: '/master/perusahaan',
                          active: false,
                          sub_menu: []
                        },
                        {
                          title: 'Unit',
                          icon: require('@/assets/icon/unit.png'),
                          link: '/master/unit',
                          active: false,
                          sub_menu: []
                        },
                        {
                          title: 'Dokumen',
                          icon: require('@/assets/icon/upload_folder.png'),
                          link: '/master/document',
                          active: false,
                          sub_menu: []
                        },
                        {
                          title: 'Import Data',
                          icon: require('@/assets/icon/import.png'),
                          link: '/master/import',
                          active: false,
                          sub_menu: []
                        },
                        {
                          title: 'Import Data Perubahan',
                          icon: require('@/assets/icon/file-download.png'),
                          link: '/master/import-perubahan',
                          active: false,
                          sub_menu: []
                        }
                      ]
                    }
                  ]
                } else {
                  menu = [
                    {
                      title: 'Dashboard',
                      icon: require('@/assets/icon/dashboard.png'),
                      link: '/dashboard',
                      active: true,
                      sub_menu: []
                    },
                    {
                      title: 'Anggaran Murni',
                      icon: require('@/assets/icon/program.png'),
                      link: '/program',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Anggaran P1',
                      icon: require('@/assets/icon/program.png'),
                      link: '/program-p1',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Anggaran Perubahan',
                      icon: require('@/assets/icon/update.png'),
                      link: '/program-perubahan',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Laporan',
                      icon: require('@/assets/icon/laporan.png'),
                      link: '/laporan',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Perkembangan Fisik & Keuangan',
                          link: '/laporan/perkembangan',
                          active: false
                        },
                        {
                          title: 'Capaian Kinerja',
                          link: '/laporan/capaian',
                          active: false
                        },
                        {
                          title: 'Kendala',
                          link: '/laporan/kendala',
                          active: false
                        },
                      ]
                    },
                    {
                      title: 'Konfigurasi',
                      icon: require('@/assets/icon/setting.png'),
                      link: '/master',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Informasi Unit',
                          icon: require('@/assets/icon/unit.png'),
                          link: '/master/informasi-unit',
                          active: false,
                          sub_menu: []
                        },
                        {
                          title: 'Dokumen',
                          icon: require('@/assets/icon/upload_folder.png'),
                          link: '/master/document',
                          active: false,
                          sub_menu: []
                        },
                        // {
                        //   title: 'Import Data Perubahan',
                        //   icon: require('@/assets/icon/file-download.png'),
                        //   link: '/master/import-perubahan',
                        //   active: false,
                        //   sub_menu: []
                        // }
                        {
                          title: 'Import Data',
                          icon: require('@/assets/icon/import.png'),
                          link: '/master/import',
                          active: false,
                          sub_menu: []
                        },
                        // {
                        //   title: 'Import Data Perubahan',
                        //   icon: require('@/assets/icon/file-download.png'),
                        //   link: '/master/import-perubahan',
                        //   active: false,
                        //   sub_menu: []
                        // }
                      ]
                    }
                  ]
  
                  let menu_gabungan = [
                    {
                      title: 'Dashboard',
                      icon: require('@/assets/icon/dashboard.png'),
                      link: '/dashboard',
                      active: true,
                      sub_menu: []
                    },
                    {
                      title: 'Anggaran Murni',
                      icon: require('@/assets/icon/program.png'),
                      link: '/program',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Anggaran P1',
                      icon: require('@/assets/icon/program.png'),
                      link: '/program-p1',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Anggaran Perubahan',
                      icon: require('@/assets/icon/update.png'),
                      link: '/program-perubahan',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Laporan',
                      icon: require('@/assets/icon/laporan.png'),
                      link: '/laporan',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Perkembangan Fisik & Keuangan',
                          link: '/laporan/perkembangan',
                          active: false
                        },
                        {
                          title: 'Capaian Kinerja',
                          link: '/laporan/capaian',
                          active: false
                        },
                        {
                          title: 'Kendala',
                          link: '/laporan/kendala',
                          active: false
                        },
                        {
                          title: 'Rekap Gabungan',
                          link: '/laporan/rekapitulasi-gabungan',
                          active: false
                        }
                      ]
                    },
                    {
                      title: 'Konfigurasi',
                      icon: require('@/assets/icon/setting.png'),
                      link: '/master',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Informasi Unit',
                          icon: require('@/assets/icon/unit.png'),
                          link: '/master/informasi-unit',
                          active: false,
                          sub_menu: []
                        },
                        {
                          title: 'Dokumen',
                          icon: require('@/assets/icon/upload_folder.png'),
                          link: '/master/document',
                          active: false,
                          sub_menu: []
                        },
                        // {
                        //   title: 'Import Data Perubahan',
                        //   icon: require('@/assets/icon/file-download.png'),
                        //   link: '/master/import-perubahan',
                        //   active: false,
                        //   sub_menu: []
                        // }
                        {
                          title: 'Import Data',
                          icon: require('@/assets/icon/import.png'),
                          link: '/master/import',
                          active: false,
                          sub_menu: []
                        },
                        // {
                        //   title: 'Import Data Perubahan',
                        //   icon: require('@/assets/icon/file-download.png'),
                        //   link: '/master/import-perubahan',
                        //   active: false,
                        //   sub_menu: []
                        // }
                      ]
                    }
                  ]
  
                  menu = user.unit_id == '42' || user.unit_id == '43' || user.unit_id == '41' || user.unit_id == '32' || user.unit_id == '4' || user.unit_id == '6' || user.unit_id == '1' || user.unit_id == '492' || user.unit_id == '501' || user.unit_id == '496' || user.unit_id == '493' || user.unit_id == '537' || user.unit_id == '500' || user.unit_id == '494' || user.unit_id == '495' || user.unit_id == '538' || user.unit_id == '492' || user.unit_id == '326' || user.unit_id == '327' || user.unit_id == '328' || user.unit_id == '330' || user.unit_id == '329' || user.unit_id == '325' || user.unit_id == '334' || user.unit_id == '335' || user.unit_id == '313' || user.unit_id == '179' || user.unit_type == "Pendidikan" || user.unit_type == "Puskesmas" ? menu_gabungan : menu
                }
  
                
                TokenService.saveToken(
                  res.results.token,
                  JSON.stringify(user),
                  JSON.stringify(menu)
                )
  
                TokenService.saveReload(false)
  
                TokenService.saveYear(new Date().getFullYear())
  
                window.location = `${process.env.BASE_URL}sidasi-dashboard`
              } else {
                this.process.form = false
                this.message.error = res.message
              }
            })
          }
        }
      }
    }
  </script>

<style scoped>
.login-container {
  min-height: 100vh;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.login-background {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #182130;
  z-index: 2;
}

.login-content {
  position: relative;
  z-index: 3;
  width: 100%;
  max-width: 420px;
  padding: 20px;
}

.login-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
}

.login-header {
  text-align: center;
  margin-bottom: 32px;
}

.logo-container {
  margin-bottom: 18px;
}

.logo {
  width: 64px;
  height: 64px;
  object-fit: contain;
  border-radius: 8px;
}

.login-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
  letter-spacing: -0.025em;
}

.login-subtitle {
  font-size: 16px;
  color: #6b7280;
  margin: 0;
  font-weight: 400;
}

.login-form {
  margin-bottom: 24px;
}

.form-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
}

.modern-input {
  border-radius: 8px !important;
  background: #ffffff !important;
  border: 1px solid #d1d5db !important;
  transition: all 0.2s ease;
}

.modern-input:hover {
  border-color: #9ca3af !important;
}

.modern-input:focus-within {
  border-color: var(--v-primary-base) !important;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.modern-input :deep(.v-input__slot) {
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 12px !important;
}

.modern-input :deep(.v-text-field__slot input) {
  font-size: 16px;
  padding: 16px 20px;
  color: #1f2937;
}

.modern-input :deep(.v-input__prepend-inner) {
  margin-left: 16px;
}

.modern-input :deep(.v-input__append-inner) {
  margin-right: 16px;
}

.error-message {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 8px;
}

.error-content {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: #dc2626;
  font-size: 14px;
  font-weight: 500;
}

.login-button {
  border-radius: 8px !important;
  height: 48px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.025em !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06) !important;
  transition: all 0.2s ease !important;
}

.login-button:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
}

.button-text {
  color: white;
  font-weight: 600;
}

.login-footer {
  text-align: center;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
}

.footer-text {
  font-size: 12px;
  color: #9ca3af;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .login-content {
    padding: 16px;
  }
  
  .login-card {
    padding: 32px 24px;
  }
  
  .login-title {
    font-size: 24px;
  }
  
  .logo {
    width: 56px;
    height: 56px;
  }
}

@media (max-width: 480px) {
  .login-card {
    padding: 24px 20px;
  }
  
  .login-title {
    font-size: 22px;
  }
  
  .login-subtitle {
    font-size: 14px;
  }
}
</style>